import React from 'react';
import VideoEmbed from '../VideoEmbed';
import {Typography} from '@/components/ui/typography';

const VideoCard = (props) => {
    if (!props.embedUrl && !props.thumb) {
        return null;
    }

    return (
        <div className="">
            <div className="">
                <Typography variant="p">
                    {props.title}
                </Typography>
                <Typography variant="muted">
                    {props.date}
                </Typography>

                <Typography variant="p">
                    {props.description}
                </Typography>
            </div>
            <div className="">
                <VideoEmbed url={props.embedUrl} thumb={props.thumb} authRequired={props.authRequired} />
            </div>
        </div>
    )
};

export default VideoCard;
